import React, { useState, useRef, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { useTheme } from "../../../Themecontext/Themecontext";

const MaintenanceDropDwonFilterBox = ({
  label,
  data = [],
  selectedValue,
  setSelectedValue,
  selectedId,
  setSelectedId,
  placeholder = "Select...",
  isMulti = true,
}) => {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = data.filter((item) =>
    item.label.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTORE",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTOREDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;

  const dropdownRef = useRef();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
      <style>
        {`
.grey-scroll::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.grey-scroll::-webkit-scrollbar-track {
  background: ${isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour3};
  border-radius: 20px;
  margin-top: 8px;
  margin-bottom: 8px;
}

.grey-scroll::-webkit-scrollbar-thumb {
  background: ${isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour7};
  border-radius: 20px;
}

.grey-scroll::-webkit-scrollbar {
  height: 4px;
}

.grey-scroll::-webkit-scrollbar-corner {
  background: transparent;
}
.search-input:focus{
  border-color: ${
    isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1
  } !important;

  box-shadow: 0 0 0 0.2rem ${
    isdark === "light" ? `${iscolour?.Colour6}40` : `${iscolourDark?.Colour8}40`
  } !important;

  outline: none !important;
`}
      </style>
      <div ref={dropdownRef} style={{ position: "relative" }}>
        {/* LABEL */}
        <div
          style={{
            color: isdark === "light" ? iscolour?.Colour3 : "#fff",
            fontWeight: "700",
            fontSize: "13px",
            marginBottom: "5px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "5px",
            }}
          >
            <span
              style={{
                color: isdark === "light" ? iscolour?.Colour11 : "#fff",
                fontWeight: "700",
                fontSize: "13px",
              }}
            >
              {label}
            </span>

            {/* +More badge */}
            {isMulti &&
              Array.isArray(selectedValue) &&
              selectedValue.length > 1 && (
                <span
                  title={selectedValue.join(", ")}
                  style={{
                    background:
                      isdark === "light"
                        ? iscolour?.Colour4
                        : iscolourDark?.Colour5,
                    color: isdark === "light" ? iscolour?.Colour6 : "#fff",
                    padding: "2px 8px",
                    borderRadius: "10px",
                    fontSize: "11px",
                    fontWeight: "600",
                    whiteSpace: "nowrap",
                  }}
                >
                  +{selectedValue.length - 1} more
                </span>
              )}
          </div>
        </div>

        {/* HEADER */}
        <div
          onClick={() => setOpen(!open)}
          style={{
            borderRadius: "12px",
            padding: "12px 20px",
            background:
              isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour4,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
            fontWeight: "500",
            color: isdark === "light" ? iscolour?.Colour12 : "#fff",
          }}
        >
          <span>
            <span>
              {isMulti
                ? Array.isArray(selectedValue) && selectedValue.length > 0
                  ? selectedValue.length <= 1
                    ? selectedValue.join(", ")
                    : selectedValue.slice(0, 1).join(", ")
                  : placeholder
                : selectedValue || placeholder}
            </span>
          </span>

          <FaChevronDown
            style={{
              transition: "0.3s",
              transform: `rotate(${open ? 180 : 0}deg)`,
            }}
          />
        </div>

        {/* DROPDOWN */}

        {open && (
          <div
            style={{
              position: "absolute",
              top: "110%",
              left: 0,
              right: 0,
              background:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour6,
              borderRadius: "12px",
              padding: "10px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
              zIndex: 999,
              maxHeight: "300px",
              overflow: "hidden",
            }}
          >
            <input
              className="search-input"
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                marginBottom: "10px",
                borderRadius: "8px",
                outline: "none",
                fontSize: "13px",
                border: `1px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour6}`,
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour3,
                color: isdark === "light" ? "#000" : "#fff",
              }}
            />

            {/* CLEAR BUTTON */}
            <div
              style={{
                width: "100%",
                marginBottom: "8px",
              }}
            >
              <button
                onClick={() => {
                  if (isMulti) {
                    setSelectedValue([]);
                    setSelectedId([]);
                  } else {
                    setSelectedValue("");
                    setSelectedId(null);
                  }
                }}
                style={{
                  width: "100%",
                  border: "none",
                  borderRadius: "10px",
                  padding: "10px",
                  fontSize: "13px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "0.25s",

                  background:
                    isdark === "light"
                      ? iscolour?.Colour7
                      : iscolourDark?.Colour11,

                  color: isdark === "light" ? "#000" : "#fff",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.02)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 10px rgba(0,0,0,0.15)";
                  e.currentTarget.style.background =
                    isdark === "light"
                      ? iscolour?.Colour7
                      : iscolourDark?.Colour11;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.background =
                    isdark === "light"
                      ? iscolour?.Colour7
                      : iscolourDark?.Colour11;
                }}
              >
                Clear All
              </button>
            </div>
            <div
              className="grey-scroll"
              style={{
                overflowX: "auto",
                overflowY: "auto",
                width: "100%",
                height: "180px",
                borderRadius: "12px",
                paddingRight: "8px",
                position: "relative",
                scrollbarWidth: "thin",
                scrollbarColor:
                  isdark === "light"
                    ? `${iscolour?.Colour7} ${iscolour?.Colour4}`
                    : `${iscolourDark?.Colour11} ${iscolourDark?.Colour3}`,
              }}
            >
              {filteredData.map((item, index) => {
                const safeSelectedId = selectedId || [];
                const safeSelectedValue = selectedValue || [];

                const isSelected = isMulti
                  ? (selectedId || []).includes(item.value)
                  : selectedId === item.value;

                return (
                  <div key={index}>
                    <div
                      onClick={() => {
                        if (isMulti) {
                          const isAlready = safeSelectedId.includes(item.value);

                          let newIds;
                          let newValues;

                          if (isAlready) {
                            newIds = safeSelectedId.filter(
                              (id) => id !== item.value,
                            );
                            newValues = safeSelectedValue.filter(
                              (val) => val !== item.label,
                            );
                          } else {
                            newIds = [...safeSelectedId, item.value];
                            newValues = [...safeSelectedValue, item.label];
                          }

                          setSelectedId(newIds);
                          setSelectedValue(newValues);
                        } else {
                          setSelectedId(item.value);
                          setSelectedValue(item.label);
                          setOpen(false);
                        }
                      }}
                      style={{
                        padding: "10px 14px",
                        borderRadius: "12px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "14px",
                        cursor: "pointer",
                        transition: "0.25s",

                        background: isSelected
                          ? isdark === "light"
                            ? iscolour?.Colour7
                            : iscolourDark?.Colour2
                          : "transparent",

                        color: isSelected
                          ? isdark === "light"
                            ? iscolour?.Colour1
                            : "#FFF"
                          : isdark === "light"
                            ? "#000"
                            : "#fff",
                      }}
                      onMouseEnter={(e) => {
                        if (!isSelected)
                          e.currentTarget.style.background =
                            isdark === "light"
                              ? iscolour?.Colour4
                              : iscolourDark?.Colour7;
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected)
                          e.currentTarget.style.background = "transparent";
                      }}
                    >
                      {item.label}
                    </div>
                    {/* Divider */}
                    <div
                      style={{
                        height: "1px",
                        width: "100%",
                        background:
                          isdark === "light"
                            ? iscolour?.Colour4
                            : iscolourDark?.Colour5,
                        margin: "4px 0",
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MaintenanceDropDwonFilterBox;
